import { MODULE } from "@/config/modules";

export interface IModuleMetaData {
	[key:string]:string;
}

export class CompanyModule {
	id:MODULE;
	name:string = "";
	public metaData:IModuleMetaData = {};


	public constructor(data:any){
		this.id = data.ID;
		this.name = data.Name;
		this.metaData = data.MetaData || {};
	}

	public getJSON():any {
		return {
			ID: this.id,
			Name: this.name,
			MetaData: this.metaData
		};
	}

	public getEditMetaDataComponent():null | string {
		if (this.id == MODULE.EXTRA_USERS){
			return "extra-users";
		}
		if (this.id == MODULE.EXTRA_DOSSIERS) {
			return "extra-dossiers";
		}
		if (this.id == MODULE.DOCUMENTS){
			return "max-documents";
		}
		if (this.id == MODULE.API_ACCESS) {
			return "api-access";
		}
		if (this.id == MODULE.ONLINE_BACKUP) {
			return "online-backup";
		}
		if (this.id == MODULE.ELECTRONISCHE_FACTURATIE) {
			return "electronische-facturatie";
		}
		return null;
	}

}